export default "__VITE_ASSET__CNw25wCV__"